export default __webpack_public_path__ + "static/media/background-sura.b56ecd74.png";